/**
 * Safely retrieves a boat image URL, handling both old and new data formats.
 * @param {object} boat
 * @param {number} [index=0]
 * @returns {string|null}
 */
export const getBoatImageUrl = (boat, index = 0) => {
  if (!boat || !boat.images || boat.images.length === 0) {
    return null;
  }
  const image = boat.images[index];
  if (typeof image === 'string') {
    return image;
  }
  if (image && typeof image.url === 'string') {
    return image.url;
  }
  return null;
};
